export const Stat=[
    {
        count:"5K",
        about:"Active Students"
    },
    {
        count:"10+",
        about:"Mentors",
    },
    {
        count:"200+",
        about:"Courses",
    },
    {
        count:"50+",
        about:"Awards"
    }
]